module.exports = "mat-dialog-actions.mat-dialog-actions {\n  background-color: whitesmoke;\n  padding: 5px 0; }\n"